import { Drawer } from "@circleco/compass/components/Drawer";

import { t } from "@/i18n-js/instance";
import { LazyMemberChecklistContent } from "@/react/components/MemberChecklist/LazyMemberChecklistContent";
import type { MemberChecklistItemWithCompletion } from "@/react/types/MemberChecklistItem";

interface MemberChecklistDrawerProps {
  container?: HTMLElement | null;
  indent?: boolean;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  previewMemberChecklistItems?: MemberChecklistItemWithCompletion[];
}

const rootLocale = "header.member_checklist";

export const MemberChecklistDrawer = ({
  open,
  onOpenChange,
  container,
  previewMemberChecklistItems,
  indent = true,
}: MemberChecklistDrawerProps) => (
  <Drawer.Root
    open={open}
    onOpenChange={onOpenChange}
    container={container}
    snapTo="half"
    indent={indent}
  >
    <Drawer.Content>
      <Drawer.Header title={t([rootLocale, "title"])} sticky />
      <LazyMemberChecklistContent
        enabled={open}
        closeChecklist={() => onOpenChange(false)}
        previewMemberChecklistItems={previewMemberChecklistItems}
        className="px-1"
      />
    </Drawer.Content>
  </Drawer.Root>
);
